import { z } from 'zod';
import { INCIDENT_STATUSES } from './incidents-cycle';
import { DOMAINS, PRIORITIES, categoryDomain } from './referentiels-metier';

export const schemaCreationIncident = z
  .object({
    domaine: z.enum(DOMAINS),
    categorie: z.string().max(60),
    titre: z.string().trim().min(5).max(200),
    description: z.string().trim().max(4000).default(''),
    priorite: z.enum(PRIORITIES).default('NORMAL'),
    province_id: z.string().uuid(),
    equipement_id: z.string().uuid().nullable().default(null),
    localisation: z.string().trim().min(2).max(250),
    latitude: z.number().min(-4).max(2.5).nullable().default(null),
    longitude: z.number().min(8).max(15).nullable().default(null),
  })
  .superRefine((v, ctx) => {
    if (categoryDomain(v.categorie) !== v.domaine)
      ctx.addIssue({
        code: 'custom',
        path: ['categorie'],
        message: 'Catégorie incompatible avec le service',
      });
    if ((v.latitude === null) !== (v.longitude === null))
      ctx.addIssue({
        code: 'custom',
        path: ['latitude'],
        message: 'Latitude et longitude doivent être renseignées ensemble',
      });
  });
export const schemaTransitionIncident = z.object({
  statut: z.enum(INCIDENT_STATUSES),
  version: z.number().int().positive(),
  commentaire: z.string().trim().max(4000).default(''),
});
export const schemaFiltreIncidents = z.object({
  statut: z.enum(INCIDENT_STATUSES).optional(),
  domaine: z.enum(DOMAINS).optional(),
  recherche: z.string().trim().max(100).default(''),
  limite: z.coerce.number().int().min(1).max(200).default(100),
  decalage: z.coerce.number().int().min(0).max(100000).default(0),
});
export type CreationIncident = z.infer<typeof schemaCreationIncident>;
export type TransitionIncident = z.infer<typeof schemaTransitionIncident>;
export type FiltreIncidents = z.infer<typeof schemaFiltreIncidents>;
export const schemaCreationSignalement = schemaCreationIncident.safeExtend({
  equipement_id: z.null().default(null),
  description: z.string().trim().min(5).max(2000),
  source: z.enum(['AGENT', 'CALL_CENTER', 'PARTNER', 'CNEE']).default('AGENT'),
});
export const schemaQualificationSignalement = z.object({
  action: z.enum(['rattacher', 'detacher', 'rejeter', 'creer_incident']),
  incident_id: z.string().uuid().optional(),
  motif: z.string().trim().min(3).max(500),
  version: z.number().int().positive(),
});
